import styled from 'styled-components';
import Offers from './Offers';

export default styled(Offers)`
  .offers {
    display: grid;
    grid-gap: 12px;
    grid-template-columns: repeat(12, 1fr);
    flex-direction: column;
    max-width: 1440px;
    margin: 0 auto;

    &__container {
      grid-column: 1 / span 12;
      grid-row: 1;
      padding: 0 2rem 6rem;
    }

    &__alert {
      display: flex;
      padding: 3.2rem;
    }

    &__loading {
      display: flex;
      margin: 2rem 0;
      justify-content: center;
    }
  }
`;
